import SpaceY from '../../../components/SpaceY';
import {
  MAX_WIDTH_639PX,
  s3CloudFrontUrlEndpoint,
} from '../../../utils/common';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';

import MissionDescriptionWrapper from './MissionSectionWrapper';

const MissionFirstSection = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  return (
    <>
      <MissionDescriptionWrapper
        headerChildren={
          <>
            지구 온난화를
            {isMobile ? <br /> : ' '}
            가속화시키는
            <br />
            농산물 폐기 문제
          </>
        }
      >
        <div className="sm:grid sm:grid-cols-2 sm:gap-48px">
          <div className="relative h-320px overflow-hidden rounded-10px sm:h-[594px] ">
            <img
              src={`${s3CloudFrontUrlEndpoint}/mission/potato.png`}
              alt="배추 사진"
              className="h-full w-full object-cover object-center"
            />
            <div
              className="absolute inset-0 z-10 flex items-end justify-center"
              style={{
                background: isMobile
                  ? 'linear-gradient(360deg, rgba(0, 0, 0, 0.5) 28.45%, rgba(0, 0, 0, 0) 64.22%)'
                  : 'linear-gradient(360deg, rgba(0, 0, 0, 0.5) 19.44%, rgba(0, 0, 0, 0) 50%)',
              }}
            >
              <p className="mb-24px text-center text-18px font-bold leading-[27px] text-white sm:text-22px sm:leading-[33px]">
                완벽한 외형이 아니란 이유로
                <br />
                버려지는 농산물이 전체 생산량의 1/3.
                <br />
                이는 전 세계적인 문제입니다.
              </p>
            </div>
          </div>
          {isMobile && <SpaceY height={48} />}
          <div className="flex flex-col justify-between">
            <p className="text-18px leading-[28.8px] text-brand-1">
              소비자의 선택을 받기 위해, 그리고 대형 유통 체인 내의 관리 편의를
              위해 균일하고 깨끗한 농산물들이 ‘정상품’으로 분류돼 시장으로
              나오고, 나머지는 규격 외 농산물로 분류됩니다.
              <br />
              <br />이 규격 외 농산물들은 맛도 영양도 다를 바 없지만, 크기가
              조금 작거나 크거나 개성있다는 이유로 적절한 판로를 찾기가
              어렵습니다.
              <br />
              <br />
              판로를 찾지 못한 농산물의 상당 양은 폐기로 이어집니다. 농산물의
              폐기는 온실가스를 배출해 환경을 오염시키고, 생산에 투입된 물과
              비료, 노동력의 낭비로 직결돼 큰 사회적·경제적·환경적 손실입니다.
            </p>
            {isMobile || (
              <>
                <div className="grid h-178px grid-cols-2 overflow-hidden rounded-10px">
                  <img
                    className="h-full w-full object-cover object-center"
                    src={`${s3CloudFrontUrlEndpoint}/mission/climate.png`}
                    alt="기후변화"
                  />
                  <img
                    className="h-full w-full object-cover object-center"
                    src={`${s3CloudFrontUrlEndpoint}/mission/potato_stream.png`}
                    alt="감자 밭"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </MissionDescriptionWrapper>
      {isMobile && (
        <>
          <SpaceY height={48} />
          <img
            src={`${s3CloudFrontUrlEndpoint}/mission/climate.png`}
            alt="기후변화"
          />
          <img
            src={`${s3CloudFrontUrlEndpoint}/mission/potato_stream.png`}
            alt="감자 밭"
          />
        </>
      )}
    </>
  );
};

export default MissionFirstSection;
